import { Directive, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IOperationInfo } from '../../../models/workflows.models';
import { CONNECTION_TYPE, OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { resolveSelectIdOrPlainValue } from '../../../utils/workflow-form-control.util';
import { WorkflowFormOperationPanelHost } from './workflow-form-operation-panel-host';

/**
 * Base de paneles de operación (NIF-530).
 * Expone `group` / helpers de ISelect y delega callbacks al host.
 */
@Directive()
export abstract class WorkflowFormOperationPanelBase {
	@Input({ required: true }) public host!: WorkflowFormOperationPanelHost;
	@Input({ required: true }) public operation!: IOperationInfo;

	/** Tipo de operación de este panel (`OPERATION_TYPE.*`). */
	protected abstract readonly operationType: OPERATION_TYPE;

	public readonly OPERATION_TYPE = OPERATION_TYPE;
	public readonly CONNECTION_TYPE = CONNECTION_TYPE;

	public get form(): FormGroup {
		return this.host.form;
	}

	/** FormGroup `operations.{TYPE}` de este panel. */
	public get group(): FormGroup {
		return this.host.form.get(`operations.${this.operationType}`) as FormGroup;
	}

	public get id(): string | undefined {
		return this.host.id;
	}

	public get reactiveFormService() {
		return this.host.reactiveFormService;
	}

	public get workflowsHelper() {
		return this.host.workflowsHelper;
	}

	/**
	 * Id plano de un control (unwrap ISelect).
	 *
	 * @param controlPath - Path relativo al `group`
	 * @param fallback - Valor si vacío
	 */
	protected readSelectId(controlPath: string, fallback = ''): string {
		return resolveSelectIdOrPlainValue(this.group.get(controlPath)?.value, fallback);
	}

	/**
	 * Valor booleano de un control del group.
	 *
	 * @param controlPath - Path relativo
	 */
	protected readBool(controlPath: string): boolean {
		return Boolean(this.group.get(controlPath)?.value);
	}

	/**
	 * Patch de un control del group.
	 *
	 * @param controlPath - Path relativo
	 * @param value - Nuevo valor
	 */
	protected patchControl(controlPath: string, value: unknown): void {
		this.group.get(controlPath)?.patchValue(value);
	}
}
